import React from "react";
import PropTypes from "prop-types";

import { Field, Control, Label, Input, Textarea } from "rbx";

import { ProductSelect, SystemCodeSelect } from "../inputs";

const OrderDetailDispatcherForm = ({ inputs, onChange }) => (
  <div style={{ width: 600, maxWidth: "100%" }}>
    <Field kind="group">
      <Control expanded>
        <ProductSelect
          icon="globe"
          label="Product"
          name="ProductRecIdRef"
          value={inputs.ProductRecIdRef}
          valueKey="RecId"
          onChange={onChange}
        />
      </Control>
      <Control>
        <Label>Quantity</Label>
        <Input
          autocomplete="new"
          defaultValue="1"
          name="Quantity"
          type="number"
          value={inputs.Quantity}
          onChange={onChange}
        />
      </Control>
    </Field>
    <Field kind="group">
      <Control expanded>
        <SystemCodeSelect
          icon="balance-scale-right"
          label="UOM"
          lookup={{ Category: "Order", Code: "UOM" }}
          name="UOMRecIdRef"
          showHelp={false}
          value={inputs.UOMRecIdRef}
          onChange={onChange}
        />
      </Control>
    </Field>
    <Field>
      <Control>
        <Label>Description</Label>
        <Textarea
          icon="globe"
          name="Description"
          rows="2"
          value={inputs.Description}
          valueKey="RecId"
          onChange={onChange}
        />
      </Control>
    </Field>
    <Field kind="group">
      <Control expanded>
        <Label>Hazmat Code</Label>
        <Input
          disabled
          required
          autocomplete="new"
          name="Hazmat"
          value={inputs.Hazmat}
          onChange={onChange}
        />
      </Control>
    </Field>
  </div>
);

OrderDetailDispatcherForm.propTypes = {
  inputs: PropTypes.object,
  onChange: PropTypes.func
};

export default OrderDetailDispatcherForm;
